import { useTheme } from '@automata/mui-theme';
import { TextField, Typography } from '@automata/ui';
import { ComponentProps } from 'react';
import { useUnmount } from 'usehooks-ts';

import { useSemicontrolledInput } from '../hooks';

export type Props = {
  TextFieldProps?: ComponentProps<typeof TextField>;
  value: string;
  handleSaveValue: (value: string) => void;
  maxLength?: number;
  error?: string | null;
};

export const SemicontrolledInput = ({
  TextFieldProps,
  maxLength,
  handleSaveValue,
  value: propValue,
}: Props) => {
  const theme = useTheme();

  const {
    onBlur,
    onChange,
    value: hookValue,
  } = useSemicontrolledInput({
    handleSaveValue,
    maxLength,
    value: propValue,
  });

  useUnmount(onBlur);

  return (
    <TextField
      {...TextFieldProps}
      InputProps={{
        ...TextFieldProps?.InputProps,
        sx: {
          ...TextFieldProps?.InputProps?.sx,
          gap: 1,
        },
        endAdornment:
          TextFieldProps?.InputProps?.endAdornment ??
          (maxLength && (
            <Typography
              variant="caption"
              color={
                hookValue.length > maxLength
                  ? theme.palette.error.main
                  : theme.palette.text.secondary
              }
            >
              {hookValue.length}/{maxLength}
            </Typography>
          )),
      }}
      onBlur={onBlur}
      onChange={onChange}
      value={hookValue}
    />
  );
};
